module.exports = __webpack_public_path__ + "static/media/openhat-808.056a627a.wav";